import { selectUser } from "modules/auth/redux/selectors";
import eventMemberApi from "modules/eventMemberList/eventMember.api";
import {
  setHasCurrentUserPlacedTicketOrder,
  setIsLoading,
  setShouldPayForEvent,
} from "modules/ticketing/redux/slice";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { isEventManager } from "modules/event/utils/eventUtils";
import { useAppDispatch } from "store/hooks";
import { selectHasTickets } from "modules/ticketing/redux/selectors";
import {
  selectCurrentEvent,
  selectIsLoadingEvent,
} from "modules/event/selectors";
import { useSelector } from "react-redux";
import { getTicketOrder } from "../../request";

export const TicketLoader = () => {
  const event = useSelector(selectCurrentEvent);
  const isEventDataLoading = useSelector(selectIsLoadingEvent);
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);
  const [isSpeaker, setIsSpeaker] = useState(false);
  const [isSpeakerDataLoading, setIsSpeakerDataLoading] = useState(true);
  const [isTicketOrderLoading, setIsTicketOrderLoading] = useState(true);
  const hasTickets = useSelector(selectHasTickets);

  useEffect(() => {
    if (!event) return;
    if (!event.isPrivate && !hasTickets) return;
    if (!user) {
      setIsSpeakerDataLoading(false);
      return;
    }

    const asyncFunction = async () => {
      setIsSpeakerDataLoading(true);

      const { isSuccess, data } = await eventMemberApi.checkEmailInvited(
        event.id,
        user.email,
      );

      if (isSuccess) {
        setIsSpeaker(data.invited && !!data.isSpeaker);
      }
      setIsSpeakerDataLoading(false);
    };
    asyncFunction();
  }, [event, hasTickets, user]);

  useEffect(() => {
    if (!event || !user || !hasTickets) return;
    if (isEventDataLoading || isSpeakerDataLoading) return;

    const isManager = isEventManager(event, user?.id);
    dispatch(setShouldPayForEvent(!isSpeaker && !isManager));
  }, [
    dispatch,
    event,
    hasTickets,
    isEventDataLoading,
    isSpeakerDataLoading,
    isSpeaker,
    user,
  ]);

  const { data, error } = useQuery({
    queryKey: ["hasCurrentUserPlacedTicketOrder", event?.id, user?.id],
    queryFn: async () => {
      if (!user || !event) return undefined;

      setIsTicketOrderLoading(true);
      return getTicketOrder(event.id);
    },
    retry: 3,
  });

  useEffect(() => {
    if (!error) return;

    dispatch(setHasCurrentUserPlacedTicketOrder(false));
    setIsTicketOrderLoading(false);
  }, [error, dispatch]);

  useEffect(() => {
    if (!data) return;

    dispatch(setHasCurrentUserPlacedTicketOrder(true));
    setIsTicketOrderLoading(false);
  }, [data, dispatch]);

  useEffect(() => {
    if (!event || isEventDataLoading) return;
    if (!user || !hasTickets) {
      dispatch(setIsLoading(false));
      return;
    }

    dispatch(setIsLoading(isSpeakerDataLoading || isTicketOrderLoading));
  }, [
    dispatch,
    event,
    isEventDataLoading,
    isSpeakerDataLoading,
    user,
    hasTickets,
    isTicketOrderLoading,
  ]);

  return null;
};
